<template>
  <div class="print-hide banner-txt">
    <v-carousel height="auto" hide-delimiters :show-arrows="false" v-model="model">
      <v-carousel-item
        v-for="(itmList, i) in bannerList"
        :key="'bn_ci_' + i"
      >
        <v-img
          :src="require('@/assets/frontend/components/FEBanner/' + itmList)"
        />
      </v-carousel-item>
    </v-carousel>
    <div class="centered">
      <p class="heading font-weight-light">CODE ADOPTIONS</p>
      <p class="subtitle font-weight-light">BY STATE, I-CODE OR COUNTRY</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FBBanner',
  data: () => ({
    model: 0,
    bannerList: [
      'Code_Adoption_1920x350_HDR_v1_notext.jpg'
    ]
  })
}
</script>
